const bannersOrder = {
    topSales: 1,
    sponsored: 2,
    recommended: 3,
    productOfTheWeek: 4,
    mmf: 5,
};
const sortByBanner = (banner1, banner2) =>
    (bannersOrder[banner1] || 0) - (bannersOrder[banner2] || 0);

const getProductBanner = (
    product,
    categoryId = '',
    hasSearchEngine,
    isSponsored = false,
) => {
    const searchEngine = hasSearchEngine ? 'banner.alternate' : 'banner';
    if ((!product || !product[searchEngine]) && !isSponsored) return null;

    const { categories = [], default: defaultBanner } = product[searchEngine];

    const banner = [...categories];

    if (isSponsored) banner.push('sponsored');

    if (banner && banner.length > 0) {
        const bannerSchema = new RegExp(
            `(([a-zA-Z]).${categoryId}$|sponsored)`,
            'g',
        );
        const bannerTypes = banner
            .filter(item => item.search(bannerSchema) > -1)
            .map(item => item.split('.')[0])
            .sort(sortByBanner);

        if (bannerTypes.length > 0) {
            return bannerTypes[0];
        }
    }
    if (defaultBanner) return defaultBanner;

    return null;
};

export default getProductBanner;
